<script setup lang="ts">
import { ref } from "vue";

interface Props {
  title: string
  tooltip?: string
  openByDefault?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  openByDefault: true
});

const isExpanded = ref(props.openByDefault);

const toggleExpanded = () => {
  isExpanded.value = !isExpanded.value;
};
</script>

<template>
  <div class="border-b pb-3 my-3">
    <div class="d-flex align-center justify-space-between mb-3">
      <div class="d-flex align-center ga-1">
        <span class="text-body-2 font-weight-bold text-grey-darken-1">{{ title }}</span>
        <v-tooltip v-if="tooltip" location="top">
          <template v-slot:activator="{ props }">
            <v-icon
              v-bind="props"
              icon="mdi-information"
              size="small"
              class="text-grey-darken-1"
            />
          </template>
          <span>{{ tooltip }}</span>
        </v-tooltip>
      </div>
      <v-btn
        icon
        variant="text"
        size="x-small"
        @click="toggleExpanded"
      >
        <v-icon
          :icon="isExpanded ? 'far fa-minus' : 'far fa-plus'"
          size="small"
        />
      </v-btn>
    </div>
    <v-expand-transition>
      <div v-show="isExpanded" class="w-100">
        <slot></slot>
      </div>
    </v-expand-transition>
  </div>
</template>

<style scoped>
.w-100 :deep(.v-input),
.w-100 :deep(.v-select),
.w-100 :deep(.v-autocomplete),
.w-100 :deep(.v-text-field) {
  width: 100%;
}
</style>
